var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"attachment-box"},[_c('i',{staticClass:"icon aufontAll h-icon-all-upload-o"}),_vm._v(_vm._s(_vm.text)+"\n  ")]),(_vm.showTemp)?_c('a',{staticClass:"attachment-link"},[_vm._v("附件模板下载")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }